import { DeviceInfo } from "../device/device-info";

export class CompleteActivityServiceOrChangeModel {
    requestId: number;
    finishDateFact: Date;
    comment: String;
    devices: DeviceInfo[] = [];
    activityId: number;
    activityResultIds: number[] = [];
    activityWorkflowTransitionId: number;
    merchantMemberName: string;
    merchantMemberEmail: string;
}